import { BASE_URL } from '@constants/api'
import {
	AddTutorialRequest,
	ListTutorialsRequest,
	ListTutorialsResponse,
	ReorderTutorialRequest,
	ShowTutorialResponse,
	UpdateTutorialRequest,
} from '@models/tutorial.model'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { setAuthorization } from '@utils/helpers'

export const tutorialApi = createApi({
	reducerPath: 'tutorialApi',
	tagTypes: ['Tutorial'],
	baseQuery: fetchBaseQuery({
		baseUrl: BASE_URL,
		prepareHeaders: setAuthorization,
	}),
	endpoints: (builder) => ({
		list: builder.query<ListTutorialsResponse, ListTutorialsRequest>({
			query: ({ search = '' }) => ({
				url: `/tutorials?search=${search}`,
				method: 'GET',
			}),
			providesTags: ['Tutorial'],
		}),
		show: builder.query<ShowTutorialResponse, { id: number }>({
			query: ({ id }) => ({
				url: `/tutorials/${id}`,
				method: 'GET',
			}),
			providesTags: ['Tutorial'],
		}),
		add: builder.mutation<void, AddTutorialRequest>({
			query: (newTutorial) => ({
				url: '/tutorials',
				method: 'POST',
				body: newTutorial,
			}),
			invalidatesTags: ['Tutorial'],
		}),
		edit: builder.mutation<void, UpdateTutorialRequest>({
			query: ({ id, ...data }) => ({
				url: `/tutorials/${id}`,
				method: 'PUT',
				body: data,
			}),
			invalidatesTags: ['Tutorial'],
		}),
		delete: builder.mutation<void, { id: number }>({
			query: ({ id }) => ({
				url: `/tutorials/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['Tutorial'],
		}),
		reorder: builder.mutation<void, ReorderTutorialRequest>({
			query: (body) => ({
				url: '/tutorials/reorder',
				method: 'POST',
				body,
			}),
			invalidatesTags: ['Tutorial'],
		}),
	}),
})
